import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperStandaloneComponent } from '../swiper/swiper-standalone.component';
import { TokenPriceAlertViewerComponent } from '../token-price-alert-viewer/token-price-alert-viewer.component';
import { Alert } from '../swap-alert/swap-alert.component'; // adapte le chemin si besoin

@Component({
  selector: 'app-mock-alert-swiper',
  standalone: true,
  imports: [CommonModule, SwiperStandaloneComponent, TokenPriceAlertViewerComponent],
  template: `
    <app-swiper>
      <div *ngFor="let alert of alerts" class="swiper-slide h-screen">
        <app-token-price-alert-viewer
          [alert]="alert"
          [currencySymbol]="currencySymbol"
          [priceMap]="priceMap"
          [defaultFiat]="defaultFiat"
          [isArabicLang]="isArabicLang"
          [chainId]="alert.chainId"
          class="w-full h-full"
          (goToSwap)="null"
          (removeAlert)="null"
          (reactivateAlert)="null"
        ></app-token-price-alert-viewer>
      </div>
    </app-swiper>
  `
})
export class MockAlertSwiperComponent {
  @Input() alerts: Alert[] = [];
  @Input() currencySymbol = '$';
  @Input() priceMap: Record<string, number> = {};
  @Input() defaultFiat = 'USD';
  @Input() isArabicLang = false;
}

